// src/index.js - entry point
import('./bootstrap');
// src/index.js - entry point
import('./bootstrap');
